import FacultyList from './FacultyList.gql';

export default FacultyList;
